export default "__VITE_ASSET__D2h$nBs9__"